import { BrowserNotificationService } from './shared/services/browser-notification/browser-notification.service';
import { ChangeDetectionStrategy, Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { ConfigService } from '@ngx-config/core';
import { Store } from '@ngrx/store';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined, isNull, isString } from 'util';
import { Subscription } from 'rxjs/Subscription';

import * as AppStateActions from './shared/state-management/actions/app-state';
import { State, showNeoFrame, getLoginState, showARGUSFrame, getUserId } from './shared/state-management/reducers';
import { WindowRef } from './shared/services/window-ref';
import { getLang } from './shared/i18n/i18n-providers';

import { WebserviceService } from './xena/core/shared/services/webservice/webservice.service';
import { BroadcastChannelService, ByChannel } from './shared/services/broadcast-channel/broadcast-channel.service';
import { CrsBridgeService } from './shared/services/crs-bridge/crs-bridge.service';

import './operators';
import { environment } from '../environments/environment';


@Component({
	selector: 'plat-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
	public showNeoFrame$: Observable<boolean> = this._store.select(showNeoFrame);
	public showARGUSFrame$: Observable<boolean> = this._store.select(showARGUSFrame);
	public isLoggedIn$: Observable<any> = this._store.select(getLoginState);
	public userId$: Observable<number> = this._store.select(getUserId);
	public showMainFrame$ = Observable.combineLatest(
		this.showNeoFrame$,
		this.showARGUSFrame$,
		(neoVisible, argusVisible) => !(neoVisible || argusVisible)
	);
	public routeTitle$: Observable<string> = this._router.events
		.filter(e => e instanceof NavigationEnd)
		.map(() => this._activatedRoute)
		.map((route) => {
			while (route.firstChild) {
				route = route.firstChild;
			}
			return route;
		})
		.filter((route) => route.outlet === 'primary')
		.mergeMap((route) => route.data)
		.map(AppComponent._extractRouteTitle);
	public argusHasBeenOpened: boolean = false;


	private _channelName: string = 'neoTripChannel';
	private argusHasBeenOpenedSubscription: Subscription;

	constructor(
		private readonly _config: ConfigService,
		private _store: Store<State>,
		private _angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
		private _window: WindowRef,
		private _bc: BroadcastChannelService,
		private _crsBridge: CrsBridgeService,
		private _webService: WebserviceService,
		private _browserNotifications: BrowserNotificationService,
		public vcr: ViewContainerRef,
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _title: Title,
	) {}

	public ngOnInit(): void {
		this._store.dispatch(new AppStateActions.SwitchLanguage(getLang(this._window.nativeWindow)));

		if (!isNullOrUndefined(localStorage.getItem('neotransfer'))) {
			this._webService.setXML(localStorage.getItem('neotransfer'));
			this._openNotify();
			localStorage.removeItem('neotransfer');
		}

		this._bc.create(this._channelName);

		this._bc.messages$.filter(ByChannel(this._channelName)).map(e => e.data).subscribe(e => {
			this._webService.setXML(e.xml);
			this._openNotify();
		});

		this._crsBridge.socketConnected$
			.switchMap(() => this._crsBridge.socket$)
			.filter(e => e && e.request === 'neotransfer' && isString(e.xml))
			.subscribe(e => {
				this._webService.setXML(e.xml);
				this._openNotify();
			});

		this.routeTitle$
			.subscribe(ttl => {
				// These fixes is needed because NEO and ARGUS are loaded combined with the XENA modules and gets the XENA route meta data
				if (window.location.href.indexOf('neo') !== -1) {
					ttl = `NEO | ${environment.title}`;
				}

				if (window.location.href.indexOf('argus') !== -1) {
					ttl = `ARGUS | ${environment.title}`;
				}

				this._title.setTitle(ttl);
			});

		// const newsDialogSubscription = this.routeTitle$.subscribe(ttl => {
		// 	if (window.location.href.indexOf('neo') === -1) {
		// 		this._newsDialogService.openNewsDialog('jt-booking-competition', this.vcr, {
		// 			boxHeight: '600px',
		// 			boxWidth: '700px',
		// 		});
		//
		// 		newsDialogSubscription.unsubscribe();
		// 	}
		// });

		this.argusHasBeenOpenedSubscription = this.showARGUSFrame$
			.filter(visible => visible === true)
			.subscribe((x) => {
				this.argusHasBeenOpened = true;
				this.argusHasBeenOpenedSubscription.unsubscribe();
			});

		this.userId$.subscribe(userId => {
			if (userId) {
				// @ts-ignore
				if (window._paq) {
					// @ts-ignore
					window._paq.push(['setUserId', userId.toString()]);
				}

				// @ts-ignore
				if (window.hj) {
					// @ts-ignore
					window.hj('identify', userId.toString());
				}
			}
		});
	}

	private _openNotify(): void {
		Notification.requestPermission().then(permissons => {
			if (permissons === 'granted') {
				const notify = this._browserNotifications.createNotification('NEO', 'An NEO übergeben', '../../../../../../assets/images/neo.png');

				if (!isNull(notify)) {
					notify.addEventListener('click', function(e) {
						window.focus();
						notify.close();
					});
				}
			}
		});
	}

	private static _extractRouteTitle(data: {[s: string]: any}): string {
		const tmpTitle = data['meta'] && data['meta']['title'] || '';
		return tmpTitle ? `${tmpTitle} | ${environment.title}` : environment.title;
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts